import DemoVideoPreview from "./DemoVideoPreview.png";
import Firmographics from "./Firmographics.png";
import MeetingTools from "./MeetingTools.png";
import Playback from "./Playback.png";
import PostToSlack from "./PostToSlack.png";
import ProductivityHero from "./ProductivityHero.png";
import RssLinksTutorial1 from "./RssLinksTutorial1.png";
import RssLinksTutorial2 from "./RssLinksTutorial2.png";

export default [
  DemoVideoPreview,
  Firmographics,
  MeetingTools,
  Playback,
  PostToSlack,
  ProductivityHero,
  RssLinksTutorial1,
  RssLinksTutorial2,
];
